
import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Action, State } from 'vuex-class';
import WAFModal from '@/components/shared/WAFModal.vue';
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";

@Component({
  components: {
    WAFModal,
    LayoutLoading,
  },
})
export default class App extends Vue {

	@Getter getWAFModalSetting!: WAFModal;

}
